import { TimerMinusIcon } from './TimerMinusIcon';

/**
 * author: Colton Wiscombe
 * id B6BD7263-1491-4D66-9847-D9E7F1B78967
 * name timer-minus
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-minus.svg
 * tags
 * - Date / Time 
 */
export const StopwatchSubtractIcon = TimerMinusIcon;
export default StopwatchSubtractIcon